"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendObjectFromKey = exports.buildObjectFromKey = exports.renameKey = exports.arraysHaveCommonElements = exports.setKey = exports.getKey = exports.deleteKey = exports.keysToLowerCase = void 0;
const errors_1 = require("@seneca/errors");
const deepCopy_1 = require("../deep-copy/deepCopy");
const validate_1 = require("../validate");
function keysToLowerCase(obj) {
    Object.keys(obj).forEach(function (key) {
        var k = key.toLowerCase();
        if (k !== key) {
            obj[k] = obj[key];
            delete obj[key];
        }
    });
    return obj;
}
exports.keysToLowerCase = keysToLowerCase;
function deleteKey(key, obj) {
    const newObject = (0, deepCopy_1.deepCopy)(obj);
    const keys = key.split('.');
    const lastKey = keys.pop();
    let objectReference = newObject;
    if (keys.length >= 1) {
        objectReference = getKey(keys.join('.'), newObject);
    }
    if (lastKey && objectReference) {
        delete objectReference[lastKey];
    }
    return newObject;
}
exports.deleteKey = deleteKey;
function getKey(key, obj) {
    const keys = key.split('.');
    const lastKey = keys.pop();
    let objectReference = obj;
    for (const aKey of keys) {
        if (objectReference[aKey] === undefined) {
            return null;
        }
        objectReference = objectReference[aKey];
    }
    return lastKey && objectReference[lastKey] !== undefined
        ? objectReference[lastKey]
        : null;
}
exports.getKey = getKey;
function setKey(key, object, value) {
    if (!(0, validate_1.isNonEmptyString)(key)) {
        throw new errors_1.InvalidArgumentError('key', 'key must be a non-empty string');
    }
    if (!(0, validate_1.isObject)(object)) {
        throw new errors_1.InvalidArgumentError('object', 'object must be an object');
    }
    const keyParts = key.split('.');
    const lastKeyPart = keyParts.pop();
    const consumedParts = [];
    let objectReference = object;
    while (keyParts.length > 0) {
        const keyPart = keyParts.shift();
        consumedParts.push(keyPart);
        if (!keyPart || !(0, validate_1.isObject)(objectReference[keyPart])) {
            throw new errors_1.SetValueOnObjectError('Intermediate node in path is set to a non object value', consumedParts.join('.'));
        }
        objectReference = objectReference[keyPart];
    }
    objectReference[lastKeyPart] = value;
}
exports.setKey = setKey;
function arraysHaveCommonElements(arr1, arr2) {
    if (!(arr1 instanceof Array) || !(arr2 instanceof Array)) {
        return false;
    }
    if (arr1.length === 0 || arr2.length === 0) {
        return false;
    }
    return arr1.some(element => arr2.indexOf(element) !== -1);
}
exports.arraysHaveCommonElements = arraysHaveCommonElements;
function renameKey(obj, keyName, newKeyName) {
    obj[newKeyName] = obj[keyName];
    delete obj[keyName];
    return obj;
}
exports.renameKey = renameKey;
function buildObjectFromKey(key) {
    if (!(0, validate_1.isNonEmptyString)(key)) {
        throw new errors_1.InvalidArgumentError('key', 'key must be a non-empty string');
    }
    const keyParts = key.split('.');
    const object = {};
    let lastLevelReference = object;
    while (keyParts.length > 0) {
        const fieldName = keyParts.shift();
        if (keyParts.length === 0) {
            lastLevelReference[fieldName] = undefined;
            break;
        }
        lastLevelReference[fieldName] = {};
        lastLevelReference = lastLevelReference[fieldName];
    }
    return object;
}
exports.buildObjectFromKey = buildObjectFromKey;
function extendObjectFromKey(key, object) {
    if (!(0, validate_1.isNonEmptyString)(key)) {
        throw new errors_1.InvalidArgumentError('key', 'key must be a non-empty string');
    }
    if (!(0, validate_1.isObject)(object)) {
        throw new errors_1.InvalidArgumentError('object', 'object must be an object');
    }
    const keyParts = key.split('.');
    let lastLevelReference = object;
    const consumedParts = [];
    while (keyParts.length > 0) {
        const fieldName = keyParts.shift();
        consumedParts.push(fieldName);
        if (keyParts.length === 0) {
            if (lastLevelReference[fieldName] === undefined) {
                lastLevelReference[fieldName] = undefined;
            }
            break;
        }
        if (lastLevelReference[fieldName] === undefined) {
            lastLevelReference[fieldName] = {};
        }
        else if (!(0, validate_1.isObject)(lastLevelReference[fieldName])) {
            throw new errors_1.ExtendObjectError('Intermediate node in path is set to a non object value', consumedParts.join('.'));
        }
        lastLevelReference = lastLevelReference[fieldName];
    }
}
exports.extendObjectFromKey = extendObjectFromKey;
